import { useEffect, useState } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { useFormattedDate } from './useFormattedDate';
export const useVehicleInspectionDueDate = (timestamp) => {
    const inspectionDueDateFallbackDescription = useI18n({
        id: 'nemo.ui.sc.highlight-label.vehicleinspectionduedate.fallback',
        defaultMessage: 'sdd fallback',
    });
    const descriptionFuture = useFormattedDate(timestamp);
    const [description, setDescription] = useState('');
    useEffect(() => {
        if (!timestamp) {
            setDescription(inspectionDueDateFallbackDescription);
            return;
        }
        if (Number.isNaN(timestamp)) {
            return;
        }
        setDescription(descriptionFuture);
    }, [descriptionFuture, timestamp]);
    return description;
};
